var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":!_vm.hasPermission,"absolute":"","z-index":"2"}},[_c('div',[_c('v-btn',{staticClass:"d-block ma-auto py-2",attrs:{"color":"error","href":_vm.$enum.DENTCO_CS_LINE,"target":"_blank"}},[_vm._v(" 此為付費功能，聯繫客服升級付費方案 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }